import { graphql, useRelayEnvironment } from 'react-relay';
import { useFetchQuery, useSegment } from '@sparknz/journeys-common';

import { useProductEligibilityCheckQuery } from '__generated__/useProductEligibilityCheckQuery.graphql';

const query = graphql`
  query useProductEligibilityCheckQuery(
    $offerId: String!
    $channel: CartChannel!
  ) {
    productEligibility(input: { offerId: $offerId, channel: $channel }) {
      isEligible
    }
  }
`;

const useProductEligibilityCheck = () => {
  const relayEnvironment = useRelayEnvironment();
  const { channel } = useSegment();

  const { isInFlight: isCheckInProgress, fetch } =
    useFetchQuery<useProductEligibilityCheckQuery>(query, relayEnvironment);

  const fetchProductEligibility = async (offerId: string) => {
    const { productEligibility } = await fetch({ offerId, channel });

    return productEligibility;
  };

  return { isCheckInProgress, fetchProductEligibility };
};

export default useProductEligibilityCheck;
